import React, { useContext, useEffect, useState } from 'react';
import { Calendar, momentLocalizer } from 'react-big-calendar';
import moment from 'moment';
import axios from 'axios';
import 'react-big-calendar/lib/css/react-big-calendar.css';
import PageTitle from '../Utilities/PageTitle'
import { BaseUrlContext } from '../Context/BaseUrl';

export default function Calender() {
    const localizer = momentLocalizer(moment);
    const [courses, setCourses] = useState([]);
    const { baseUrl } = useContext(BaseUrlContext);
    async function getAllCourses() {

        await axios.post(`${baseUrl}/get_courses`)
            .then(response => {
                // Handle the response
                if (response.data.Ecode === 200) {
                    console.log(response.data.Edata);
                    const transformedCourses = response.data.Edata.map(course => ({
                        id: course.id,
                        title: course.name,
                        start: new Date(),
                        end: new Date(),
                        url: `#/courses/${course.name}/${course.id}`
                    }));
                    setCourses(transformedCourses);
                }

            })
            .catch(error => {

                // Handle any errors
                console.error(error);
            });

    }
    const eventStyleGetter = (event, start, end, isSelected) => {
        // Customize the styling of the event if needed
        // For example, you can set different background colors for different courses
        return {
            style: {
                backgroundColor: 'rgb(8 153 130)',
                color: '#fff'
            }
        };
    };

    const EventComponent = ({ event }) => (
        <div>
            <a href={event.url} className='text-white events-calendar'>{event.title}</a>
        </div>
    );
    useEffect(() => {
        getAllCourses();
    }, [])

    return <>
        {/* <!-- Start main-content --> */}
        <div className="main-content-area">
            {/* <!-- Section: page title --> */}
            <PageTitle title='Calender' homeLink='/' homePage='Home' currentLink='/training-events-calender' />

            {/* <!-- Section: calendar --> */}
            <section>
                <div className="container py-md-5 py-4">
                    <div className="section-content text-center">
                        <div className="row">
                            <div className="col-md-12" style={{ height: '600px' }}>

                                <Calendar
                                    localizer={localizer}
                                    events={courses}
                                    startAccessor="start"
                                    endAccessor="end"
                                    titleAccessor="title"
                                    eventPropGetter={eventStyleGetter}
                                    components={{
                                        event: EventComponent
                                    }}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
        {/* <!-- end main-content --> */}
    </>
}
